import {View} from "react-native";

function RowSpace(props: any) {
    return <View style={{width: props.w ?? 10}}/>
}

function ColumnSpace(props: any) {
    return <View style={{height: props.h ?? 15}}/>
}

function FullWidthView(props: any) {
    return <View {...props} style={[{width: "100%"}, props.style]}>{props.children}</View>
}


export {
    RowSpace,
    FullWidthView,
    ColumnSpace
}